import { Navigate } from 'react-router-dom';

import { homeFor } from '../lib/roles';
import { useAppSelector } from '../app/hooks';
import { RouteFallback } from '../ui/RouteFallback';
import { sessionIsRecoverable } from '../lib/session';
import { selectUser, selectUserHydrated } from '../store/selectors/auth';

// Role-aware landing: waits for /auth/me/ so a coach never flashes the admin shell.
export const HomeRedirect = () => {
  const user = useAppSelector(selectUser);
  const hydrated = useAppSelector(selectUserHydrated);

  if (!sessionIsRecoverable()) return <Navigate to="/login" replace />;
  if (!hydrated) return <RouteFallback />;
  return <Navigate to={homeFor(user)} replace />;
};
